import styled from "styled-components";
import { NavLink as NavLinkUi } from "react-router-dom";

export const Letter = styled("div")`
  width: 100%;
  height: 100%;
  border-radius: 100%;
  background: ${({ theme }) => theme.colors.Black25};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.Black};
`;

export const Link = styled(NavLinkUi) <{ isanicon: boolean }>`
  display: ${({ isanicon }) => (isanicon ? 'flex' : 'block')};
  align-items: ${({ isanicon }) => (isanicon ? 'center' : 'none')};
  justify-content: ${({ isanicon }) => (isanicon ? 'center' : 'none')};
  width: 160px;
  height: 160px;
  font-weight: 700;
  text-decoration: none;
  padding: 2px;
  border-radius: 100%;
  background: ${({ theme }) => theme.colors.Black};
`;
